<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Import Table from Excel"
    >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Excel file:"
      >
        <div>
          <b-form-file
            v-model.trim="excelFile"
            class="custom-file-input"
            :class="{ 'is-invalid': $v.excelData.$error }"
            :disabled="inProgress"
            placeholder="Choose a file..."
            style="opacity: 1;"
          />
          <b-form-invalid-feedback
            v-if="!$v.excelData.required"
            >
            Excel file is required
          </b-form-invalid-feedback>
        </div>
        <b-alert
          variant="success"
          dismissible
          :show="excelDataProvided"
          @dismissed="resetExcelData"
          class="mt-3"
        >
          Excel data provided.
        </b-alert>
      </b-form-group>
      <div>
        <b-button
          variant="success"
          type="submit"
          >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
// validations
import { required } from 'vuelidate/lib/validators'

let $ = window.$

export default {
  props: ['dashboards'],
  data () {
    return {
      inProgress: false,
      excelFile: null,
      excelData: null,
      excelDataProvided: false
    }
  },
  watch: {
    excelFile () {
      if (!this.excelFile) {
        this.excelData = null
        return
      }
      this.$readExcelFileToJSON(this.excelFile, (result) => {
        this.excelDataProvided = true
        this.excelData = result
      })
    }
  },
  computed: {
    ...mapState([
      'currentDash'
    ])
  },
  methods: {
    openModal () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    closeModal () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save () {
      // console.log(this.excelData)
      // return
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      this.$store.commit('addProcess', {
        process: 'importFromExcel',
        message: 'Importing'
      })

      await db.dashboards.importFromExcel(this.excelData, this.currentDash, true)

      this.$store.commit('deleteProcess', 'importFromExcel')
      this. inProgress = false
      this.resetExcelData()
      this.closeModal()
    },
    resetExcelData () {
      this.excelData = false
      this.excelFile = null
      this.excelDataProvided = false
    }
  },
  created () {
    eventBus.$on('showDataGridExcelImportModal', () => {
      this.openModal()
    })
  },
  mounted () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).remove()
    }
  },
  validations: {
    excelData: {
      required
    }
  }
}
</script>

<style>
.custom-file-input.is-invalid .custom-file-label {
  border: 1px solid #fb6340;
}
</style>
